import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  // mode:'history',
  routes: [
    {
      path: '/login',
      name: 'login',
      component: resolve => require(['@/views/login'], resolve),
      meta: {
        title: '登录',
        keepAlive: false,
        isBack: false
      }
    },
    {
      path: '/',
      name: 'index',
      component: resolve => require(['@/views/index'], resolve),
      meta: {
        title: '首页',
        keepAlive: false,
        isBack: false
      }
    },
    {
      path: '/customerList',
      name: 'customerList',
      component: resolve => require(['@/views/customerList'], resolve),
      meta: {
        title: '顾客列表',
        keepAlive: true,
        isBack: false
      }
    },
    {
      path: '/customerDetail',
      name: 'customerDetail',
      component: resolve => require(['@/views/customerDetail'], resolve),
      meta: {
        title: '顾客详情',
        keepAlive: false,
        isBack: false
      }
    },
    {
      path: '/customerAdd',
      name: 'customerAdd',
      component: resolve => require(['@/views/customerAdd'], resolve),
      meta: {
        title: '顾客新增',
        keepAlive: false,
        isBack: false
      }
    },
    {
      path: '/customerEdit',
      name: 'customerEdit',
      component: resolve => require(['@/views/customerEdit'], resolve),
      meta: {
        title: '顾客编辑',
        keepAlive: false,
        isBack: false
      }
    },
    {
      path: '/activityList',
      name: 'activityList',
      component: resolve => require(['@/views/activityList'], resolve),
      meta: {
        title: '活动列表',
        keepAlive: false,
        isBack: false
      }
    },
    {
      path: '/activityAdd',
      name: 'activityAdd',
      component: resolve => require(['@/views/activityAdd'], resolve),
      meta: {
        title: '活动新增',
        keepAlive: false,
        isBack: false
      }
    },
    {
      path: '/activityCopy',
      name: 'activityCopy',
      component: resolve => require(['@/views/activityCopy'], resolve),
      meta: {
        title: '活动复制',
        keepAlive: false,
        isBack: false
      }
    },
    {
      path: '/activityDetail',
      name: 'activityDetail',
      component: resolve => require(['@/views/activityDetail'], resolve),
      meta: {
        title: '活动详情',
        keepAlive: false,
        isBack: false
      }
    },
    {
      path: '/reduceList',
      name: 'reduceList',
      component: resolve => require(['@/views/reduceList'], resolve),
      meta: {
        title: '卡耗列表',
        keepAlive: false,
        isBack: false
      }
    },
    {
      path: '/buyList',
      name: 'buyList',
      component: resolve => require(['@/views/buyList'], resolve),
      meta: {
        title: '购买列表',
        keepAlive: true,
        isBack: false
      }
    },
    {
      path: '/buyAdd',
      name: 'buyAdd',
      component: resolve => require(['@/views/buyAdd'], resolve),
      meta: {
        title: '新增购买',
        keepAlive: false,
        isBack: false
      }
    },
    {
      path: '/buyEdit',
      name: 'buyEdit',
      component: resolve => require(['@/views/buyEdit'], resolve),
      meta: {
        title: '编辑购买',
        keepAlive: false,
        isBack: false
      }
    },
    {
      path: '/reduceAdd',
      name: 'reduceAdd',
      component: resolve => require(['@/views/reduceAdd'], resolve),
      meta: {
        title: '卡耗新增',
        keepAlive: false,
        isBack: false
      }
    },
    {
      path: '/reduceDetail',
      name: 'reduceDetail',
      component: resolve => require(['@/views/reduceDetail'], resolve),
      meta: {
        title: '卡耗明细',
        keepAlive: false,
        isBack: false
      }
    },
    {
      path: '/buyDetail',
      name: 'buyDetail',
      component: resolve => require(['@/views/buyDetail'], resolve),
      meta: {
        title: '购买详情',
        keepAlive: false,
        isBack: false
      }
    },
    {
      path: '/buyRefund',
      name: 'buyRefund',
      component: resolve => require(['@/views/buyRefund'], resolve),
      meta: {
        title: '退补操作',
        keepAlive: false,
        isBack: false
      }
    },
    {
      path: '/customerDetailExtAdd',
      name: 'customerDetailExtAdd',
      component: resolve => require(['@/views/customerDetailExtAdd'], resolve),
      meta: {
        title: '顾客档案追踪新增',
        keepAlive: false,
        isBack: false
      }
    },
    {
      path: '/customerDetailExt',
      name: 'customerDetailExt',
      component: resolve => require(['@/views/customerDetailExt'], resolve),
      meta: {
        title: '顾客档案追踪修改',
        keepAlive: false,
        isBack: false
      }
    },
    {
      path: '/customerDetailExtView',
      name: 'customerDetailExtView',
      component: resolve => require(['@/views/customerDetailExtView'], resolve),
      meta: {
        title: '顾客档案追踪查看',
        keepAlive: false,
        isBack: false
      }
    },
    {
      path: '/experienceAdd',
      name: 'experienceAdd',
      component: resolve => require(['@/views/experienceAdd'], resolve),
      meta: {
        title: '体验新增',
        keepAlive: false,
        isBack: false
      }
    },
    {
      path: '/experienceDetail',
      name: 'experienceDetail',
      component: resolve => require(['@/views/experienceDetail'], resolve),
      meta: {
        title: '体验详情',
        keepAlive: false,
        isBack: false
      }
    },
    {
      path: '/workReportList',
      name: 'workReportList',
      component: resolve => require(['@/views/workReportList'], resolve),
      meta: {
        title: '工作汇报列表',
        keepAlive: false,
        isBack: false
      }
    },
    {
      path: '/workReportAdd',
      name: 'workReportAdd',
      component: resolve => require(['@/views/workReportAdd'], resolve),
      meta: {
        title: '工作汇报新增',
        keepAlive: false,
        isBack: false
      }
    },
    {
      path: '/workReportDetail',
      name: 'workReportDetail',
      component: resolve => require(['@/views/workReportDetail'], resolve),
      meta: {
        title: '工作汇报详情',
        keepAlive: false,
        isBack: false
      }
    },
    {
      path: '/businessReportList',
      name: 'businessReportList',
      component: resolve => require(['@/views/businessReportList'], resolve),
      meta: {
        title: '分配业绩列表',
        keepAlive: false,
        isBack: false
      }
    },
    {
      path: '/businessReportAdd',
      name: 'businessReportAdd',
      component: resolve => require(['@/views/businessReportAdd'], resolve),
      meta: {
        title: '分配业绩新增',
        keepAlive: false,
        isBack: false
      }
    },
    {
      path: '/businessReportEdit',
      name: 'businessReportEdit',
      component: resolve => require(['@/views/businessReportEdit'], resolve),
      meta: {
        title: '分配业绩修改',
        keepAlive: false,
        isBack: false
      }
    },
    {
      path: '/businessReportDetail',
        name: 'businessReportDetail',
        component: resolve => require(['@/views/businessReportDetail'], resolve),
        meta: {
            title: '分配业绩详情',
            keepAlive: false,
            isBack: false
        }
    },
    {            
      path: '/themeActivityList',            
      name: 'themeActivityList',            
      component: resolve => require(['@/views/themeActivityList'], resolve),            
      meta: {                
        title: '主题活动列表',                
        keepAlive: true,                
        isBack: false            
      }        
    },        
    {            
      path: '/themeActivityAdd',            
      name: 'themeActivityAdd',            
      component: resolve => require(['@/views/themeActivityAdd'], resolve),            
      meta: {                
        title: '主题活动新增',                
        keepAlive: false,                
        isBack: false            
      }        
    },        
    {            
      path: '/themeActivityEdit',            
      name: 'themeActivityEdit',            
      component: resolve => require(['@/views/themeActivityEdit'], resolve),            
      meta: {                
        title: '主题活动编辑',                
        keepAlive: false,                
        isBack: false            
      }        
    },
    {
      path: '/reportList',
      name: 'reportList',
      component: resolve => require(['@/views/reportList'], resolve),
      meta: {
        title: '报表分析',
        keepAlive: false
      }
    },
    {
      path: '/reportProductSaleOut',
      name: 'reportProductSaleOut',
      component: resolve => require(['@/views/reportProductSaleOut'], resolve),
      meta: {
        title: '物料年度销售出库表',
        keepAlive: false,
        isBack: false
      }
    },
    {
      path: '/reportSale',
      name: 'reportSale',
      component: resolve => require(['@/views/reportSale'], resolve),
      meta: {
        title: '销售报表',
        keepAlive: false,
        isBack: false
      }
    },
    {
      path: '/reportStat',
      name: 'reportStat',
      component: resolve => require(['@/views/reportStat'], resolve),
      meta: {
        title: '门店综合报表',
        keepAlive: false,
        isBack: false
      }
    },
    {
      path: '/reportKdStaffSale',
      name: 'reportKdStaffSale',
      component: resolve => require(['@/views/reportKdStaffSale'], resolve),
      meta: {
        title: '员工销售额报表',
        keepAlive: false,
        isBack: false
      }
    },
    {
      path: '/reportKdStoreSale',
      name: 'reportKdStoreSale',
      component: resolve => require(['@/views/reportKdStoreSale'], resolve),
      meta: {
        title: '销售业绩确认单',
        keepAlive: false,
        isBack: false
      }
    },
    {
      path: '/reportSaleConfirm',
      name: 'reportSaleConfirm',
      component: resolve => require(['@/views/reportSaleConfirm'], resolve),
      meta: {
        title: '业绩确认单',
        keepAlive: false,
        isBack: false
      }
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js